import Colors from '../../theme/Colors';

const styles = {
  root: {
    height: '100%'
  }
}

export default styles;
